import { Notify } from 'quasar'

Notify.registerType('positive', {
  icon: 'fa-light fa-check',
  progress: true,
  color: 'green-5',
  textColor: 'white'
})

Notify.registerType('negative', {
  icon: 'fa-light fa-triangle-exclamation',
  progress: true,
  color: 'red-5',
  textColor: 'white'
})

Notify.registerType('warning', {
  icon: 'fa-light fa-triangle-exclamation',
  progress: true,
  color: 'orange-5',
  textColor: 'white'
})

export function useNotify() {
  function notify(options) {
    Notify.create(options)
  }

  function successNotify(message) {
    notify({
      type: 'positive',
      message,
      badgeStyle: 'opacity: 0',
      html: true,
      position: 'top',
      actions: [
        { icon: 'fa-light fa-times', color: 'white', round: true, handler: () => { /* ... */ } }
      ]
    })
  }

  function errorNotify(message) {
    notify({
      type: 'negative',
      message,
      badgeStyle: 'opacity: 0',
      html: true,
      position: 'top',
      actions: [
        { icon: 'fa-light fa-times', color: 'white', round: true, handler: () => { /* ... */ } }
      ]
    })
  }

  function warningNotify(message) {
    notify({
      type: 'warning',
      message,
      badgeStyle: 'opacity: 0',
      html: true,
      position: 'top',
      actions: [
        { icon: 'fa-light fa-times', color: 'white', round: true, handler: () => { /* ... */ } }
      ]
    })
  }

  function infoNotify(message) {
    notify({
      type: 'info',
      message,
      badgeStyle: 'opacity: 0',
      html: true,
      position: 'top',
      textColor: 'primary',
      actions: [
        { icon: 'fa-light fa-times', color: 'primary', round: true, handler: () => { /* ... */ } }
      ]
    })
  }

  return { notify, successNotify, errorNotify, warningNotify, infoNotify }
}
